<div [ngClass]="{searchContainer: true, searching: isSearching}">
  <div class="searchFieldNoButtonContainer">
    <input class="searchField"
      placeholder="Search Members"
      [(ngModel)]="searchWord"
      (keyup)="search()"
      [attr.aria-label]="'write the query for members search'"
      >
      <i class="material-icons searchIcon">search</i>
    </div>
    @if (isSearching) {
      <button (click)="closeSearch()" class="closeSearch">
        <i class="material-icons">close</i>
      </button>
    }

    @if (isSearching || isAdding) {
      <div class="results members">
        @if (canEditGroups) {
          <ul>
            @for (user of filteredUsers; track user) {
              <li>
                <app-member
                  [applicationType]="applicationType"
                  [member]="user.userData"
                  [alreadyMember]="user.teamMember"
                  [projectLocked]="projectLocked"
                  [isSearch]="true"
                  (addSignal)="addUser($event)"
                ></app-member>
              </li>
            }
            @for (group of filteredGroups; track group) {
              <li class="foundGroup">
                <app-member-group
                  [group]="group.groupData"
                  [applicationType]="applicationType"
                  [projectLocked]="projectLocked"
                  [isSearch]="true"
                  [alreadyMember]="group.teamMember"
                  [foundUserName]="searchWord"
                  [hideWordSearched]="hideWordSearched"
                  (addSignal)="addUserGroup($event)"
                ></app-member-group>
              </li>
            }
            @if (filteredUsers.length == 0 && filteredGroups.length == 0) {
              <li class="noResults">
                No items match your search.
              </li>
            }
          </ul>
        }
        @if (!canEditGroups) {
          <ul>
            @for (user of filteredUsers; track user) {
              <li>
                <app-member
                  [applicationType]="applicationType"
                  [member]="user.userData"
                  [alreadyMember]="user.teamMember"
                  [projectLocked]="projectLocked"
                  [isSearch]="true"
                  (addSignal)="addUser($event)"
                ></app-member>
              </li>
            }
            @if (filteredUsers.length == 0) {
              <li class="noResults">
                No items match your search.
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
